import wretch from "wretch";

export function login(body, callbackUrl, redirectUrl, authHost) {
  return wretch()
    .options({ credentials: "include" })
    .url(`${authHost}/sso-login`)
    .query({
      "callback-url": callbackUrl,
      "redirect-url": redirectUrl,
    })
    .post(body)
    .json((res) => {
      return res;
    })
    .catch((ex) => Promise.reject(new Error(ex.message)));
}

export function register(body, callbackUrl, redirectUrl, authHost) {
  return wretch()
    .options({ credentials: "include" })
    .url(`${authHost}/sso-signup`)
    .query({
      "callback-url": callbackUrl,
      "redirect-url": redirectUrl,
    })
    .post(body)
    .json((res) => {
      return res;
    })
    .catch((ex) => Promise.reject(ex));
}

// Logout the User
export function logout() {
  return wretch()
    .options({ credentials: "include" })
    .url("/logout")
    .get()
    .res(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

// Send the email with OTP for verification
export function verifyEmail(email) {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/v1/members/verification-email")
    .post({ member: { email } })
    .json(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

// Auth link
export function emailLink(email, redirectUrl) {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/auth/v1/users/send-verification-link")
    .post({
      email: email,
      "redirect-url": redirectUrl,
    })
    .json(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

// Send the email with OTP for verification for resetting the password
export function forgotPassword(email, redirectUrl) {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/auth/v1/users/forgot-password")
    .post({ email, "current-host": redirectUrl })
    .res(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

// Verify the email by validating OTP
export function verifyEmailOtp(otp, id, password = null) {
  const member = {
    "verification-status": "email",
  };

  if (password) {
    member.password = password;
  }

  return wretch()
    .options({ credentials: "same-origin" })
    .url(`/api/v1/members/${id}`)
    .patch({
      otp: parseInt(otp),
      member: member,
    })
    .json((res) => Promise.resolve(res))
    .catch((ex) => Promise.reject(ex));
}

// Returns the current User
export function getUser() {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/v1/members/me")
    .get()
    .json((res) => Promise.resolve(res))
    .catch((ex) => Promise.reject(ex));
}

// Reset the password
export function resetPassword(token, password, repeatPassword) {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/auth/v1/users/reset-password-with-token")
    .post({
      token,
      "new-password": password,
      "confirm-password": repeatPassword,
    })
    .json((res) => Promise.resolve(res))
    .catch((ex) => {
      if (ex.message) {
        const res = JSON.parse(ex.message);
        return Promise.reject(res.error);
      }

      return Promise.reject(ex);
    });
}

// Update User Information
export function updateUserInformation(data) {
  return wretch()
    .options({ credentials: "same-origin" })
    .url("/api/member/metadata")
    .post(data)
    .res(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

// Get Author Stories
export function getAuthorStories(authorId, params) {
  return wretch()
    .url(`/api/v1/authors/${authorId}/collection`)
    .query(params)
    .get()
    .json((response) => (response.items || []).map((item) => item.story));
}

// Get Search Stories

const getQueryObject = (offset, itemsToLoad, queryParams, storyFields) => {
  const { q, ...otherParams } = queryParams;

  if (!q)
    return {
      fields: storyFields,
      offset: offset,
      limit: itemsToLoad,
      sort: "latest-published",
      ...otherParams,
    };

  return {
    fields: storyFields,
    offset: offset,
    limit: itemsToLoad,
    ...queryParams,
  };
};
export function getSearchStories(offset, itemsToLoad, queryParams) {
  const storyFields =
    "headline,subheadline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata,tags,cards";

  return wretch()
    .url("/api/v1/advanced-search")
    .query(getQueryObject(offset, itemsToLoad, queryParams, storyFields))
    .get()
    .json((response) => response);
}

// Get Poll Stories
export function getPollingStories(collectionSlug, fields) {
  return wretch()
    .url(`api/v1/collections/${collectionSlug}`)
    .query({
      "item-type": "story",
      fields: fields,
    })
    .get()
    .json((response) => response.items || []);
}

// Get all the authors
export function getAllAuthors() {
  return wretch()
    .url("/api/v1/authors")
    .query({ limit: 1 })
    .get()
    .json((response) => {
      return wretch()
        .url("/api/v1/authors")
        .query({ limit: response.page.total })
        .get()
        .json((response) => response.authors);
    });
}

// Get Story
export function getStory(storyId) {
  return wretch()
    .url(`/api/v1/stories/${storyId}`)
    .get()
    .json((response) => response || {});
}

// Get Breaking News
export function getBreakingNews() {
  return wretch()
    .url(`/api/v1/collections/breaking-news`)
    .get()
    .json((response) => (response.items || []).map((item) => item.story));
}

// Get the JWT token (User should be logged in to call this api)
export function getJwt(integrationsId) {
  return fetch(`/access-token/integrations/${integrationsId}`).then((response) => response);
}

/* Metype Bookmarks - Starts Here */

// Get Comments of a User
export function getUserComments(metypeConfig, jwt, page, perPage = 20) {
  const url = `${metypeConfig.metypeHost}/api/v1/activity/comments`;

  return wretch(url)
    .query({
      account_id: metypeConfig.metypeAccountId,
      per_page: perPage,
      page,
      jwt,
    })
    .headers({ Origin: `${metypeConfig.metypeHost}` })
    .get()
    .json((response) => response.data || []);
}

// Get Bookmark Stories of particular user
export function getBookmarkStories(metypeConfig, token, page = 1) {
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/bookmarks`;

  return wretch()
    .url(url)
    .query({ jwt: token, page: page })
    .get()
    .json((response) => {
      if (!(response.data && response.data.length)) {
        return [];
      }

      return response.data.map((item) => item.attributes.metadata);
    })
    .catch((ex) => Promise.reject(ex));
}

// Create a Bookmark
export function createBookmark(metypeConfig, data, token) {
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/bookmarks/bulk_upload?jwt=${token}`;

  return wretch()
    .headers({ "Content-Type": "application/json", origin: `${metypeConfig.metypeHost}` })
    .url(url)
    .post(data)
    .json((response) => (response.data && response.data.length ? response.data[0] : null))
    .catch((ex) => {
      console.log(ex.message);
      return Promise.reject(ex);
    });
}

// Get bookmark by Story Url
export function getBookmarkByPageId(metypeConfig, storyUrl, token) {
  const base64Url = window.btoa(unescape(encodeURI(encodeURI(storyUrl))));
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages/${base64Url}/bookmark`;

  return wretch()
    .url(url)
    .query({ jwt: token })
    .get()
    .json((response) => response.data || null);
}

// Get Comments of a story
export function getCommentsCountForStories(metypeConfig, encodedUrl) {
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages?page_ids=${encodedUrl}`;

  return wretch()
    .url(url)
    .get()
    .json((response) => response || []);
}

// Delete a Bookmark
export function deleteBookmarkByPageId(metypeConfig, storyUrl, token) {
  const base64Url = window.btoa(unescape(encodeURI(encodeURI(storyUrl))));
  const url = `${metypeConfig.metypeHost}/api/v1/accounts/${metypeConfig.metypeAccountId}/pages/${base64Url}/bookmark`;

  return wretch()
    .url(url)
    .query({ jwt: token })
    .delete()
    .res(() => Promise.resolve())
    .catch((ex) => Promise.reject(ex));
}

/* Metype Bookmarks - Ends Here */
export const getSoriesBySlug = async (storySlug) => {
  const response = await fetch(`/api/v1/stories-by-slug?slug=${storySlug}`);
  const storyObject = await response.json();
  return storyObject.story;
};

// Get first author object from current Story
export const getAuthorObj = async (authorId) => {
  if (authorId) {
    const response = await fetch(`/api/v1/authors/${authorId}`);
    const authorObject = await response.json();
    return authorObject.author;
  }
};

// Sign an image
export function signImage(fileName, mimeType) {
  const url = `/api/sign?file-name=${fileName}&mime-type=${mimeType}`;

  return wretch()
    .url(url)
    .get()
    .json((response) => response || {});
}

export function getDistrictTopics() {
  const url = "/front-end/district-topics";

  return wretch()
    .url(url)
    .get()
    .json((response) => response || {});
}

export function getCountriesList() {
  const url = "/front-end/countries-list";

  return wretch()
    .url(url)
    .get()
    .json((response) => response || []);
}

export function menuGroups(hostUrl) {
  const url = hostUrl ? `${hostUrl}/api/v1/menu-groups` : "/api/v1/menu-groups";

  return wretch()
    .url(url)
    .get()
    .json((response) => response || []);
}

export const uploadS3ToTemp = (res, formdata) => {
  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
  };

  return fetch(`${res.action}`, requestOptions).then((response) => {
    return response;
  });
};

export const memberProfileUpdate = (obj) => {
  const patchObj = {};
  if (obj.name) {
    patchObj.name = obj.name;
  } else if (obj.s3Key) {
    patchObj["temp-s3-key"] = obj.s3Key;
  }
  const url = "/api/v1/members/profile";
  return wretch()
    .url(url)
    .patch(patchObj)
    .json((res) => Promise.resolve(res))
    .catch((ex) => Promise.reject(ex));
};
